import React from 'react';
import moment from 'moment';
import { MdOutlineStarPurple500 } from 'react-icons/md';
import { formatDateAndTime } from '../../../function/Helper';

interface IProps {
  feedbackInfo: any;
}

const SpecificFeedbackDetails = (props: IProps) => {
  const { feedbackInfo } = props;

  return (
    <div className="xl:h-[calc(100vh-264px)] flex flex-col gap-3 p-2 xl:p-4 overflow-y-auto">
      {/* Raised On */}
      <div className="flex gap-3">
        <label className="text-sm text-white font-bold">Received on</label>
        <label className="text-sm text-white font-normal">
          {feedbackInfo.createdAt ? formatDateAndTime(feedbackInfo.createdAt) : '-'}
        </label>
      </div>

      {/* Rating */}
      <div className="flex gap-12">
        <label className="text-sm text-white font-bold">Rating</label>
        <ul className="flex space-x-4 justify-center mt-1">
          {new Array(5).fill(1).map((_, idx) => (
            <MdOutlineStarPurple500
              key={idx}
              color={idx < feedbackInfo.rating ? '#FFF04C' : '#D9D9D9'}
              className="h-4 w-4"
            />
          ))}
        </ul>
      </div>

      {/* Message */}
      <div className="flex gap-9">
        <label className="text-sm text-white font-bold">Message</label>
        <label className="text-sm text-white font-normal break-all">
          {feedbackInfo.comment ? feedbackInfo.comment : '-'}
        </label>
      </div>
    </div>
  );
};

export default SpecificFeedbackDetails;
